<template>
  <v-layout column>
    <v-flex xs12>
      <v-list dense class="transparent mb-0">
        <v-list-item>
          <v-list-item-action>
            <v-icon>fad fa-user</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-if="showDetails">
              {{ customerUser.name.first }} {{ customerUser.name.last }}
            </v-list-item-title>
            <v-list-item-title class="align-end" v-else>Content Hidden</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="canEdit">
            <v-menu v-model="editName" :close-on-content-click="false" :nudge-width="200" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon text x-small v-bind="attrs" v-on="on"><v-icon>fad fa-edit</v-icon></v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <v-form lazy-validation>
                    <v-container fluid grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                          <v-text-field label="First name" v-model="firstName" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field label="Last name" v-model="lastName" required></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text @click="editName = false">
                    Cancel
                  </v-btn>
                  <v-btn color="accent" @click="save()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon>fad fa-phone</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-if="showDetails">{{ customerUser.phone }}</v-list-item-title>
            <v-list-item-title class="align-end" v-else>Content Hidden</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="canEdit">
            <v-menu v-model="editPhone" :close-on-content-click="false" :nudge-width="200" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon text x-small v-bind="attrs" v-on="on"><v-icon>fad fa-edit</v-icon></v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <v-form lazy-validation>
                    <v-container fluid grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field label="Phone number" v-model="phone" required></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text @click="editPhone = false">
                    Cancel
                  </v-btn>
                  <v-btn color="accent" @click="save()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon>fad fa-envelope</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-if="showDetails"
              ><a :href="`mailto:${customerUser.email}`">{{ customerUser.email }}</a></v-list-item-title
            >
            <v-list-item-title class="align-end" v-else>Content Hidden</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="canEdit">
            <v-menu v-model="editEmail" :close-on-content-click="false" :nudge-width="200" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon text x-small v-bind="attrs" v-on="on"><v-icon>fad fa-edit</v-icon></v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <v-form lazy-validation>
                    <v-container fluid grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field label="First name" v-model="email" required></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text @click="editEmail = false">
                    Cancel
                  </v-btn>
                  <v-btn color="accent" @click="save()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list dense three-line class="my-0 py-0">
        <v-list-item>
          <v-list-item-action>
            <v-icon>fad fa-map-marked-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content class="list__tile__xl">
            <v-list-item-title class="text--primary" v-if="showDetails">
              <span v-if="customer.address.line_1">{{ customer.address.line_1 }},</span>
              <span v-if="customer.address.line_2">{{ customer.address.line_2 }},</span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="showDetails">
              <span v-if="customer.address.line_3">{{ customer.address.line_3 }},</span>
              <span v-if="customer.address.line_4">{{ customer.address.line_4 }},</span>
              <span v-if="customer.address.line_5">{{ customer.address.line_5 }},</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="showDetails">
              <span v-if="customer.address.post_code">{{ customer.address.post_code }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>Content Hidden</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense two-line class="transparent">
        <v-list-item>
          <v-list-item-action>
            <v-icon>fad fa-building</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>Company Type</v-list-item-subtitle>
            <v-list-item-title class="align-end" v-if="customer.is_limited">Limited</v-list-item-title>
            <v-list-item-title class="align-end" v-if="!customer.is_limited">Non-Limited</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="UserHasRole('Platform') || UserHasRole('Provider')">
          <v-list-item-action>
            <v-icon>fad fa-id-card</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>Business Ref</v-list-item-subtitle>
            <v-list-item-title class="align-end" v-if="showDetails">
              <a :href="businessLink" target="_blank">{{ customer.business_ref }}</a>
            </v-list-item-title>
            <v-list-item-title class="align-end" v-else>Content Hidden</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="(UserHasRole('Platform') || UserHasRole('Provider')) && customer.is_limited">
          <v-list-item-action>
            <v-icon>fad fa-industry</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>SIC Codes</v-list-item-subtitle>
            <v-list-item-title class="align-end" v-if="showDetails">
              {{ sicCodes }}
            </v-list-item-title>
            <v-list-item-title class="align-end" v-else>Content Hidden</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn v-if="UserHasRole('Broker')" class="mt-5 ml-5">Download Suitability Report</v-btn>
      <v-list v-if="UserHasRole('Broker')" dense three-line class="my-0 mt-5 py-0">
        <v-list-item>
          <v-list-item-content class="list__tile__xl">
            <v-list-item-title>Communications sent to:</v-list-item-title>
            <v-list-item-title>
              <v-radio-group value="sme">
                <v-radio label="Broker" value="broker" />
                <v-radio label="SME" value="sme" />
              </v-radio-group>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'customer-info',
  props: ['customer', 'page'],
  data: () => ({
    editName: false,
    editPhone: false,
    editEmail: false,
    updateData: {
      firstName: null,
      lastName: null,
      email: null,
      phone: null
    }
  }),
  methods: {
    ...mapActions(['addNotification', 'updateRegistration']),
    save() {
      let updateData = this.customer;
      updateData.users[0].name.first = this.firstName ?? updateData.users[0].name.first;
      updateData.users[0].name.last = this.lastName ?? updateData.users[0].name.last;
      updateData.users[0].email = this.email ?? updateData.users[0].email;
      updateData.users[0].phone = this.phone ?? updateData.users[0].phone;
      this.updateRegistration({ updateData }).then(() => {
        this.editName = false;
        this.editPhone = false;
        this.editEmail = false;
        this.selectCustomer(this.customer.id);
      });
    }
  },
  computed: {
    ...mapGetters(['UserHasRole', 'FunderEnquiries', 'PlatformUser']),
    canEdit: function() {
      return this.UserHasRole('Platform');
    },
    showDetails() {
      if (
        this.UserHasRole('Platform') ||
        this.UserHasRole('Call Centre') ||
        this.UserHasRole('Property Broker') ||
        this.UserHasRole('Broker')
      ) {
        return true;
      }
      const enquiry = _.find(this.FunderEnquiries.Active, ['customer.id', this.customer.id]);
      return !_.isUndefined(enquiry) && enquiry.customer.name.provider !== 'Content Hidden';
    },
    businessLink() {
      if (this.customer.is_limited && this.showDetails) {
        return `https://beta.companieshouse.gov.uk/company/${this.customer.business_ref}`;
      }

      return null;
    },
    customerUser() {
      return _.isUndefined(this.customer.users[0]) ? [] : this.customer.users[0];
    },
    firstName: {
      get() {
        return this.updateData.firstName ?? this.customerUser.name.first;
      },
      set(value) {
        this.updateData.firstName = value;
      }
    },
    lastName: {
      get() {
        return this.updateData.lastName ?? this.customerUser.name.last;
      },
      set(value) {
        this.updateData.lastName = value;
      }
    },
    email: {
      get() {
        return this.updateData.email ?? this.customerUser.email;
      },
      set(value) {
        this.updateData.email = value;
      }
    },
    phone: {
      get() {
        return this.updateData.phone ?? this.customerUser.phone;
      },
      set(value) {
        this.updateData.phone = value;
      }
    },
    sicCodes() {
      return this.customer.registered_company_sic_codes
        ? JSON.parse(this.customer.registered_company_sic_codes).join(', ')
        : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.list__tile__xl {
  ::v-deep .v-list__tile {
    height: auto !important;
  }
  ::v-deep .v-list__tile__action {
    height: auto;
    align-self: flex-start;
  }
}
.v-list-item .v-list-item__content {
  user-select: text !important;
}
</style>
